import {
  GET_LIST_PRIVATE_COUPON_REQUEST,
  GET_LIST_PRIVATE_COUPON_SUCCESS,
  GET_LIST_PRIVATE_COUPON_FAILURE,
  GET_LIST_COUPON_BUDGET_REQUEST,
  GET_LIST_COUPON_BUDGET_SUCCESS,
  GET_LIST_COUPON_BUDGET_FAILURE,
  GET_COUPON_LIMIT_REQUEST,
  GET_COUPON_LIMIT_SUCCESS,
  GET_COUPON_LIMIT_FAILURE
} from "src/actions/couponActions";
import produce from "immer";

const initialState = {
  privateCoupons: [],
  totalPrivateCoupon: 0,
  couponBudget: [],
  couponLimit: {},
  loadingGets: false,
  loadingGetOne: false,
  loadingUpdate: false
};

const couponReducer = (state = initialState, action) => {
  switch (action.type) {
    // private coupon
    case GET_LIST_PRIVATE_COUPON_REQUEST: {
      return produce(state, (draft) => {
        draft.privateCoupons = [];
        draft.loadingGets = true;
      });
    }

    case GET_LIST_PRIVATE_COUPON_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.privateCoupons = response;
        draft.totalPrivateCoupon = total;
        draft.loadingGets = false;
      });
    }

    case GET_LIST_PRIVATE_COUPON_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGets = false;
      });
    }

    // private coupon
    case GET_LIST_COUPON_BUDGET_REQUEST: {
      return produce(state, (draft) => {
        draft.couponBudget = [];
        draft.loadingGets = true;
      });
    }

    case GET_LIST_COUPON_BUDGET_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.couponBudget = response;
        draft.loadingGets = false;
      });
    }

    case GET_LIST_COUPON_BUDGET_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGets = false;
      });
    }

    case GET_COUPON_LIMIT_REQUEST: {
      return produce(state, (draft) => {
        draft.couponLimit = {};
        draft.loadingGetOne = true;
      });
    }

    case GET_COUPON_LIMIT_SUCCESS: {
      const {response} = action.payload;
      return produce(state, (draft) => {
        draft.couponLimit = response;
        draft.loadingGetOne = false;
      });
    }

    case GET_COUPON_LIMIT_FAILURE: {
      return produce(state, (draft) => {
        draft.loadingGetOne = false;
      });
    }

    default: {
      return state; // We return the default state here
    }
  }
};

export default couponReducer;
